import React, { useState } from "react";
import {
  Paper,
  List,
  ListItemButton,
  ListItemText,
  Collapse,
  Divider,
  IconButton,
  Box,
  Tooltip,
} from "@mui/material";
import SolarPowerIcon from "@mui/icons-material/SolarPower";
import GridOffIcon from "@mui/icons-material/GridOff";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useLocation, useNavigate } from "react-router-dom";

const stages = [
  { label: "#1 Requirement Analysis", value: "stage1" },
  { label: "#2 Kit Selection", value: "stage2" },
  { label: "#3 Smart Summary", value: "stage3" },
];

const PlanSidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const isOnGrid = location.pathname.includes("onGrid");
  const isOffGrid = location.pathname.includes("offGrid");

  const [collapsed, setCollapsed] = useState(false);

  const handleNavigate = (path) => navigate(path);
  const toggleCollapse = () => setCollapsed(!collapsed);

  return (
    <Paper
      elevation={3}
      sx={{
        width: collapsed ? 60 : 250,
        borderRadius: 2,
        p: 1,
        mr: 3,
        bgcolor: "background.paper",
        transition: "width 0.3s ease",
        overflowX: "hidden",
        marginBottom: "2rem",
      }}
    >
      <Box display="flex" justifyContent="flex-end">
        <Tooltip title={collapsed ? "Expand" : "Collapse"}>
          <IconButton size="small" onClick={toggleCollapse} sx={{
            left: collapsed? "-4px" : undefined,
          }}>
            {collapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </IconButton>
        </Tooltip>
      </Box>

      <List component="nav">
        {/* On-Grid Plans */}
        <ListItemButton
          onClick={() => handleNavigate("/planner/onGrid")}
          sx={{
            paddingLeft: collapsed ? "12px" : undefined, // 1.5 * 8 = 12px
          }}
        >
          <SolarPowerIcon
            sx={(theme) => ({
              mr: collapsed ? 0 : 1,
            })}
          />

          {!collapsed && <ListItemText primary="On-Grid Plans" />}
          {!collapsed && (isOnGrid ? <ExpandLess /> : <ExpandMore />)}
        </ListItemButton>
        {!collapsed && (
          <Collapse in={isOnGrid} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {stages.map((stage) => (
                <ListItemButton
                  key={stage.value}
                  sx={{ pl: 4 }}
                  selected={isOnGrid && location.pathname.includes(stage.value)}
                  onClick={() => handleNavigate(`/planner/onGrid/${stage.value}`)}
                >
                  <ListItemText primary={stage.label} />
                </ListItemButton>
              ))}
            </List>
          </Collapse>
        )}

        <Divider sx={{ my: 1 }} />

        {/* Off-Grid Plans */}
        <ListItemButton
          onClick={() => handleNavigate("/planner/offGrid")}
          sx={{
            paddingLeft: collapsed ? "12px" : undefined, // 1.5 * 8 = 12px
          }}
        >
          <GridOffIcon sx={{ mr: collapsed ? 0 : 1 }} />
          {!collapsed && <ListItemText primary="Off-Grid Plans" />}
          {!collapsed && (isOffGrid ? <ExpandLess /> : <ExpandMore />)}
        </ListItemButton>
        {!collapsed && (
          <Collapse in={isOffGrid} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {stages.map((stage) => (
                <ListItemButton
                  key={stage.value}
                  sx={{ pl: 4 }}
                  selected={isOffGrid && location.pathname.includes(stage.value)}
                  onClick={() => handleNavigate(`/planner/offGrid/${stage.value}`)}
                >
                  <ListItemText primary={stage.label} />
                </ListItemButton>
              ))}
            </List>
          </Collapse>
        )}
      </List>
    </Paper>
  );
};

export default PlanSidebar;
